import React, { useEffect } from "react";

const ContactFormHubspot = () => {
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/v2.js";
    document.body.appendChild(script);

    script.addEventListener("load", () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          region: "na1",
          portalId: "6898561",
          target: "#contactform",
          formId: "38a21cad-edec-4357-9b4f-5a922762a0ae"
        });
      }
    });
    window.scrollTo(0, 0);
  }, []);

  return (
    <div>
      <div id="contactform" ></div>
    </div>
  );

};

export default ContactFormHubspot;